/**
 * SpotifyHeader — top row of the expanded player.
 *
 * Shows the "Workout Music" eyebrow, the connected account name (with a Crown
 * for Premium), and the right-side icon buttons: search-toggle, browse-link
 * (full /app/music page), and collapse-down.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Music, Crown, Search, ExternalLink, ChevronDown } from "lucide-react";

export default function SpotifyHeader({
  status,
  isPremium,
  onToggleSearch,
  onClose,
}) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <Music className="w-3.5 h-3.5 text-[#1DB954] shrink-0" />
      <span className="label-eyebrow text-white/40 text-[10px]">Workout Music</span>
      {status?.connected && (
        <span className="text-[9px] uppercase tracking-widest text-[#1DB954]/90 inline-flex items-center gap-1">
          {status.premium ? <Crown className="w-2.5 h-2.5" /> : null}
          {status.profile?.display_name || "linked"}
        </span>
      )}
      <div className="flex-1" />
      {status?.connected && isPremium && (
        <button
          onClick={onToggleSearch}
          className="rounded-full p-1.5 text-white/50 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Search"
          data-testid="spotify-pill-search-toggle"
        >
          <Search className="w-3.5 h-3.5" />
        </button>
      )}
      <Link
        to="/app/music"
        className="rounded-full p-1.5 text-white/50 hover:text-white hover:bg-white/10 transition-colors"
        data-testid="spotify-browse-link"
        title="Open full Music page"
      >
        <ExternalLink className="w-3.5 h-3.5" />
      </Link>
      <button
        onClick={onClose}
        className="rounded-full p-1.5 text-white/50 hover:text-white hover:bg-white/10 transition-colors"
        data-testid="spotify-pill-close"
        aria-label="Minimise"
      >
        <ChevronDown className="w-4 h-4" />
      </button>
    </div>
  );
}
